import { InjectionToken } from '@angular/core';

/** Un rectángulo `[[oeste, sur], [este, norte]]`, como lo pide `fitBounds`. */
export type LimitesMapa = [[number, number], [number, number]];

/**
 * Dónde arranca un mapa al que no se le dice dónde: el área del cliente.
 *
 * **Por qué un token.** El mapa vive en `ui/`, que por regla de capas no conoce
 * entidades de negocio, y "el área del cliente" es `cliente.poligono`. El mapa
 * pide los límites y quien los sabe es el dominio, cableado en `app.config.ts`.
 *
 * Se consulta al crear cada mapa (el cliente elegido puede haber cambiado desde
 * el anterior). `null` cuando el cliente no tiene polígono: el mapa cae a su
 * centro por defecto.
 */
export type EncuadreInicialMapa = () => LimitesMapa | null;

export const ENCUADRE_INICIAL_MAPA = new InjectionToken<EncuadreInicialMapa>(
  'encuadre inicial del mapa',
  { factory: () => () => null },
);
